import React from "react";
import PropTypes from "prop-types";
import utils from "../../utils/utils";
import shihuo from 'shihuo-lib/dist/shihuo-lib';
import CountDown from "../../utils/countDown";
import "./style.less";
import px2rem from "../../utils/px2rem";

class PipelineImage extends React.Component {

  constructor(props) {
    super(props);
    this.pageId = typeof window !== "undefined" && window.location.host === "www.shihuo.cn"
      ? window.location.href.indexOf('zt-public/stage') > -1
        ? window.location.pathname.split("/")[4]
        : window.location.pathname.split("/")[3]
      : 0;
  }

  imgClick = () => {
    if (this.props.templateName === 'toufang') {
      const m_device_id = window.localStorage.getItem('m_device_id') || '';
      shihuo.uploadTrack(
        {
          from: 'dyPlacing',
          block: 'download',
          command: this.props.kouling,
          deviceId: m_device_id,
          pti: {
            id: 'dyPlacing:download',
            name: '',
            biz: JSON.stringify({
              h5Url: typeof window !== "undefined" && window.location.href,
              pageId: this.pageId,
              legoAb: this.props.legoAb,
              command: this.props.kouling,
              deviceId: m_device_id
            }),
            pageOptions: {
              lego_page_id: utils.getPageId(),
              legoAb: this.props.legoAb
            }
          },
        },
        `shihuo://www.shihuo.cn?route=h5&url=${encodeURIComponent(window.location.href)}`
      );
      
      let { link = "" } = this.props.config;
      utils.handleToufangClick({
        link,
        props: this.props,
      })
      return
    }
  };

  render() {
    const { src = "", bounceTime = "0.6s", fixBottom, width, bounce, isDownload, marginTop,  marginBottom, openCountDown, countDownTime, countDownTextColor, countDownBgColor } = this.props.config;
    if(utils.isShihuo() && isDownload){
      return (<div></div>)
    }
    if(fixBottom){
      let fixedBottom = fixBottom;
      if (utils.isIphoneX()) {
        if (fixedBottom.indexOf('vw') >= 0) {
          fixedBottom = fixedBottom.replace('vw', '');
          fixedBottom = (Number(fixedBottom) + 5) + 'vw';
        } else if (fixedBottom.indexOf('px') >= 0) {
          fixedBottom = fixedBottom.replace('px', '');
          fixedBottom = (Number(fixedBottom) + 20) + 'px';
          fixedBottom = px2rem(fixedBottom)
        } else {
          fixedBottom = Number(fixedBottom) + 23;
        } 
      }
      return (
        <div className='pipeline-image fixed' style={{position: 'fixed', bottom: fixedBottom, zIndex: 99}} {...this.props['customAttributes']}>
          <div className={[bounce ? 'bounce' : '']} onClick={this.imgClick}>
            <img style={{width, marginTop, marginBottom, animationDuration: bounceTime}} src={utils.formatImgUrl(src, this.props.webpSupport)} alt="" />
            { 
              openCountDown && countDownTime && (
                <CountDown
                  fixed={true}
                  countDownTime={countDownTime}
                  countDownTextColor={countDownTextColor}
                  countDownBgColor={countDownBgColor}
                />
              )
            }
          </div>
        </div>
      )
    }
    return (
      <div className="pipeline-image" {...this.props['customAttributes']}>
        <div className={[bounce ? 'bounce' : '']} onClick={this.imgClick}>
          <img style={{width, marginTop, marginBottom, animationDuration: bounceTime}} src={utils.formatImgUrl(src, this.props.webpSupport)} alt="" />
          { 
            openCountDown && countDownTime && (
              <CountDown
                fixed={false}
                countDownTime={countDownTime}
                countDownTextColor={countDownTextColor}
                countDownBgColor={countDownBgColor}
              />
            )
          }
        </div>
      </div>
    );
  }

  removeURLParameter(url, parameter) {
    var urlparts = url.split('?');
    if(urlparts.length >= 2) {
        //参数名前缀
        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //循环查找匹配参数
        for(var i = pars.length; i-- > 0;) {
            if(pars[i].lastIndexOf(prefix, 0) !== -1) {
                //存在则删除
                pars.splice(i, 1);
            }
        }

        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
  }
}

PipelineImage.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineImage };
export default PipelineImage;



// WEBPACK FOOTER //
// ./components/pipeline-image/index.js